// @ts-ignore
import { createApp } from 'vue';
// @ts-ignore
import App from './App.vue';
// @ts-ignore
import router from './router';
// @ts-ignore
import store from './store';
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import axios from 'axios';

import 'tdesign-vue-next/es/style/index.css';
import TDesign from 'tdesign-vue-next';
import TDesignElementAdapter from './plugins/tdesignElementAdapter';
import './assets/global.css';

const resizeObserverError = 'ResizeObserver loop completed with undelivered notifications';

window.addEventListener(
  'error',
  (event) => {
    if (event.message?.includes(resizeObserverError)) {
      event.stopImmediatePropagation();
    }
  },
  true
);

// @ts-ignore
const app = createApp(App);

const options = {
  position: POSITION.TOP_RIGHT,
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false,
};

// @ts-ignore
app.use(Toast, options);
// @ts-ignore
app.use(router);
// @ts-ignore
app.use(store);
app.config.globalProperties.$axios = axios;
// @ts-ignore
app.use(TDesign);
// @ts-ignore
app.use(TDesignElementAdapter);

// @ts-ignore
app.mount('#app');
